import { useEffect, useState } from "react";
import { unitType } from "../../../util/unitType";
import { toast } from "react-toastify";
import { reformatData } from "../../../util/helperFunctions";
import { getModelPlotData } from "../../model/util/modelUtils";
import { fetchExpressions } from "../../../api/sensorApi";
import { fetchData } from "../../../api/cancuiApi";

const features = [
    {
        id: "CC_Temperature",
        name: "Temperature",
    },

];


const minMaxTempFeatures = [
    {
        id: "MinCUITemperature",
        name: "Min CUI Temperature",
    },
    {
        id: "MaxCUITemperature",
        name: "Max CUI Temperature",
    },
];


const getTempFlags = async (id, start, end) => {
    const spec = {
        subject_filter: `sensor.id = '${id}'`,
        start: start.format("YYYY-MM-DD"),
        end: end.format("YYYY-MM-DD"),
        // units: [unitType(units, 'temperature')],
        expressions: ["Cluster_Data"],
        interval: "D",
    }


    try {
        const res = await fetchExpressions("SensorExpression", spec);
        return {
            isClusterData: res?.result?.[id]?.Cluster_Data?._data || []
        };
    } catch (error) {
        console.error(error);
        toast.error("Error fetching Temperature Flags Data");
        return { isClusterData: [] };
    }
}


const fetchMinMaxTempIds = async (site) => {
    try {
        const res = await fetchData("CC_Tree", "fetch", {
            filter: `site.id=='${site}'`,
        });
        if (!res || !res.objs || res.objs.length === 0) {
            toast.error("No temperature IDs found for the specified site.");
            return [];
        }
        const ids = res.objs[0].id;
        return ids;

    } catch (error) {
        console.error("Error fetching temperature IDs:", error);
        toast.error("Error fetching temperature IDs. Please try again later.");
        throw error;
    }
};

const fetchMinMaxTempData = async (id, start, end, units) => {
    if (!id) {
        toast.error("No ID specified.");
        return [];
    }
    const spec = {
        subject_filter: `sensor.id = '${id}'`,
        start: start.format("YYYY-MM-DD"),
        end: end.format("YYYY-MM-DD"),
        expressions: [
            "MinCUITemperature", 
            "MaxCUITemperature"
        ],
        units: [unitType(units, 'temperature'), unitType(units, 'temperature')],
        interval: "D",
    };

    try {
        const res = await fetchExpressions("SensorExpression", spec );
        return reformatData([res]);
    }
    catch (error) {
        console.error("Error fetching temperature data:", error);
        toast.error("Error fetching temperature data. Please try again later.");
        return [];
    }

}


const getTemperatureData = async (id, start, end, units) => {
    const spec = {
        subject_filter: `sensor.id = '${id}'`,
        start: start.format("YYYY-MM-DD"),
        end: end.format("YYYY-MM-DD"),
        units: [unitType(units, 'temperature')],
        expressions: ["CC_Temperature"],
        interval: "D",
    }


    try {
        const res = await fetchExpressions("SensorExpression", spec);
        console.log("Fetched temperature data:", res);
        console.log("Reformatted temperature data:", reformatData([res]));
        return reformatData([res]);
    } catch (error) {
        console.error("Error fetching temperature data:", error);
        toast.error("Error fetching temperature data. Please try again later.");
        return [];
    }
}


function useGetTempChartData(id, start, end, units, site) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {

        async function fetchData() {
            if (id && site) {
                setLoading(true);
                try {
                    // Fetch temperature data
                    const tempData = await getTemperatureData(id, start, end, units);
                    if (tempData.length > 0) {
                        // Fetch temperature flags
                        const { isClusterData } = await getTempFlags(id, start, end, units);
                        console.log(tempData)
                        const formattedData = getModelPlotData(tempData[0], features, units, id, isClusterData);
                        console.log("Formatted Temperature Data:", formattedData);
                        // // Fetch min/max temperature IDs
                        // const tempId = await fetchMinMaxTempIds(site, start, end, units);

                        // Fetch min/max temperature data
                        const minMaxTempData = await fetchMinMaxTempData(id, start, end, units);
                        if (minMaxTempData.length === 0) {
                            toast.error("No min/max temperature data found for the specified ID.");
                            return;
                        }
                        const minMaxFormattedData = getModelPlotData(minMaxTempData[0], minMaxTempFeatures, units, id);
                        console.log("Formatted Min/Max Temperature Data:", minMaxFormattedData);
                        setData([...formattedData, ...minMaxFormattedData]);
                    } else {
                        toast.error("No temperature data found for the specified ID.");
                    }
                }
                catch (error) {
                    console.error("Error fetching temperature data:", error);
                    toast.error("Error fetching temperature data. Please try again later.");
                } finally {
                    setLoading(false);
                }

            }
        }
        fetchData();

    }, [id, start, end, units, site]);

    return { data, loading }
}

export default useGetTempChartData;